import { render, staticRenderFns } from "./caseQuickSelect.vue?vue&type=template&id=71491aea&scoped=true"
import script from "./caseQuickSelect.vue?vue&type=script&lang=js"
export * from "./caseQuickSelect.vue?vue&type=script&lang=js"
import style0 from "./caseQuickSelect.vue?vue&type=style&index=0&id=71491aea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71491aea",
  null
  
)

export default component.exports